import React, {Component} from 'react'
import {Button, Input, message, Popconfirm, Select, Table} from 'antd'
import moment from 'moment'
import {strVal} from '../../../../../modules/Utils'
import Members from '../../../../../api/Members'
import CustomTable from '../../../../../elements/Table/CustomTable'

const Option = Select.Option
const EditableCell = ({editable, value, onChange}) => (
  <div>
    {editable ? (
      <Input value={value} onChange={e => onChange(e.target.value)} />
    ) : (
      value
    )}
  </div>
)
const EditableCellRep = ({editable, value, onChange, list}) => (
  <div>
    {editable ? (
      <Select
        style={{width: '100%'}}
        value={value}
        showSearch
        onChange={(value, label) => onChange(value, label)}
        placeholder="Select a Rep"
        filterOption={(input, option) =>
          option?.props?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
        }>
        {list.map(l => (
          <Option value={l._id}>{l.fn}</Option>
        ))}
      </Select>
    ) : (
      value
    )}
  </div>
)

class Representative extends Component {
  uuid = moment().millisecond()

  constructor(props) {
    super(props)
    this.state = {
      data: [],
      list: [],
      editing: false,
      fetching: true,
      loading: false,
    }
    this.key = props.member._key
    this.type = props.member.kind
  }

  async componentDidMount() {
    let list = []
    if (this.type === 'organisation') list = await this.api.individual()
    else list = await this.api.organisation()
    await this.fetch()
    this.setState({list})
  }

  fetch = async () => {
    this.setState({fetching: true})
    let response = await this.api.representatives.list(this.key)
    let data = await response.json()
    this.cacheData = data.map(item => ({...item}))
    this.setState({data, fetching: false})
  }
  api = new Members()
  cacheData = []
  columns = [
    {
      Header: 'Name',
      accessor: 'name',
      Cell: ({value, original}) =>
        this.renderColumnsRep(value, original, 'name'),
    },
    {
      Header: 'Position',
      accessor: 'position',
      Cell: ({value, original}) =>
        this.renderColumns(value, original, 'position'),
    },
    {
      Header: 'Operation',
      accessor: 'operation',
      Cell: ({value, original}) => {
        const {editable} = original
        return (
          <div className="editable-row-operations">
            {editable ? (
              <span>
                <Popconfirm
                  title="Sure to Save?"
                  onConfirm={() => this.save(original.key)}>
                  <a>Save</a>
                </Popconfirm>
                <span className="ant-divider" />
                <Popconfirm
                  title="Sure to cancel?"
                  onConfirm={() => this.cancel(original.key)}>
                  <a>Cancel</a>
                </Popconfirm>
              </span>
            ) : (
              [
                <Popconfirm
                  title="Sure to Remove?"
                  onConfirm={() => this.remove(original._id)}>
                  <a>Remove</a>
                </Popconfirm>,
              ]
            )}
          </div>
        )
      },
    },
  ]

  handleChange(value, key, column) {
    const newData = [...this.state.data]
    const target = newData.filter(item => key === item.key)[0]
    if (target) {
      target[column] = value
      this.setState({data: newData})
      this.cacheData = newData.map(item => ({...item}))
    }
  }

  renderColumns(text, record, column) {
    return (
      <EditableCell
        editable={record.editable}
        value={text}
        onChange={value => this.handleChange(value, record.key, column)}
      />
    )
  }

  renderColumnsRep(text, record, column) {
    return (
      <EditableCellRep
        editable={record.editable}
        value={text}
        list={this.state.list}
        onChange={value => this.handleChange(value, record.key, column)}
      />
    )
  }

  edit(key) {
    const newData = [...this.state.data]
    const target = newData.filter(item => key === item.key)[0]
    if (target) {
      target.editable = true
      this.setState({data: newData})
    }
  }

  remove = async _id => {
    let newData = [...this.state.data]
    let target = newData.find(item => _id === item._id)
    target.removed = true
    this.setState({data: newData, fetching: true})
    await this.api.representatives.remove(this.key, target)
    await this.fetch()
  }

  save = async key => {
    const newData = [...this.state.data]
    const target = newData.filter(item => key === item.key)[0]
    if (target) {
      delete target.editable
      await this.api.representatives.add(this.key, target)
      await this.fetch()
    }
  }

  cancel(key) {
    const newData = [...this.state.data]
    const target = newData.filter(item => key === item.key)[0]
    if (target) {
      Object.assign(target, this.cacheData.filter(item => key === item.key)[0])
      delete target.editable
      this.setState({data: newData})
    }
  }

  add = () => {
    const newData = [...this.state.data]
    newData.unshift({key: (this.uuid++).toString(), editable: true})
    this.setState({data: newData})
  }
  submit = async () => {
    try {
      let member = Object.assign({}, {_key: this.key}, {files: this.state.data})
      this.setState({loading: true})
      const response = await this.api.update(member)
      this.setState({loading: false})
      let updatedMember = await response.json()
      this.setState({data: updatedMember.files})
      this.props.handleUpdated()
      message.success('Updated')
    } catch (error) {
      this.setState({
        loading: false,
      })
      message.error(strVal(error, 'errorMessage'))
    }
  }

  render() {
    return (
      <CustomTable
        CreateButton={() => (
          <Button type={'primary'} onClick={this.add}>
            New
          </Button>
        )}
        fetch={this.fetch}
        isFilterable={true}
        fetching={this.state.fetching}
        columns={this.columns}
        data={this.state.data.filter(i => i.removed !== true)}
      />
    )
  }
}

export default Representative
